import * as React from 'react';

function SvgSiteCircle(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={24} height={24} viewBox="0 0 24 24" {...props}>
      <path d="M12 0a12 12 0 110 24 12 12 0 010-24zm0 2a10 10 0 100 20 10 10 0 000-20zm3.57 5.25l4.93 4.97-1.36 1.38-2.64-2.67V16h-1.85v-5.07L12 13.6l-2.65-2.67V16H7.5v-5.07L4.86 13.6 3.5 12.22l4.93-4.97 3.57 3.6 3.57-3.6z" />
    </svg>
  );
}

export default SvgSiteCircle;
